import CallRtpSettingsStatic from '../Classes/Call/CallRtpSettingsStatic';
import RecordingCallMediaConstraintsStatic from './RecordingCallMediaConstraintsStatic';

class RecordingCallConfig {
    constructor() {
        this.isCaller = null;
        this.constraints = new RecordingCallMediaConstraintsStatic();
        this.constraints.videoWidth = 640;
        this.constraints.videoHeight = 480;
        this.constraints.videoFrameRate = 1;
        this.constraints.audioChannelCount = 1;
        this.constraints.audioSampleRate = 16000;
        this.constraints.audioGoogleEnhancements = true;
        this.rtpSettings = new CallRtpSettingsStatic();
    }

    copy() {
        const configCopy = new RecordingCallConfig();

        configCopy.isCaller = this.isCaller;
        configCopy.constraints = this.constraints.copy();
        configCopy.rtpSettings = this.rtpSettings.copy();

        return configCopy;
    }
}

export default new RecordingCallConfig();
